exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3bGcIdmsKgrvjKYsXCsSGh{margin:0 0 20px 0}\n", ""]);

// Exports
exports.locals = {
	"CheckboxGroup": "_3bGcIdmsKgrvjKYsXCsSGh"
};